import styled from 'styled-components';
import SahamDialog from 'components/SahamDialog';

export const FormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 15px;
  .formEl {
    width: 100%;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .sued-party-title {
    margin-bottom: 5px;
  }
  .info-item {
    height: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color: #00000061;
  }
  .info-sub-item {
    width: 88px;
    height: 15px;
    left: 0px;
    top: 0px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 15px;
    color: #0880bc;
    margin-top: 5px;
  }
`;
export const StyledSecondaryButton = {
  color: '#FF3400',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  textTransform: 'unset',
  padding: '8px',
  borderRadius: '4px',
  border: '1px solid #FF523A',
};
export const Dialog = styled(SahamDialog)`
  .content {
    font-size: 18px;
    min-width: 400px;
    margin-bottom: 20px;
  }
  .info-message {
    padding: 10px 0;
    font-style: italic;
    font-size: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
  }
`;
